export enum PaletteType {
  SURVEY = "survey",
  CHAT = "chat",
  CO_OCCURRENCE = "co-occurrence",
}
